import Dropdown from './Dropdown';
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-dropdown/es/index.js
// module id = 534
// module chunks = 0 1